import React from 'react';
import PropTypes from 'prop-types';

import {
  ButtonGroup, Dropdown, DropdownButton,
} from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';

export default function InvoiceCard({ size, invoice }) {
  let classsName = 'mt-2';
  if (size && size.width > 800) {
    classsName = 'col-lg-6 mt-2';
  } else if (size && size.width > 700) {
    classsName = 'col-lg-6 mt-2 size-650';
  } else if (size && size.width > 650) {
    classsName = 'col-lg-6 mt-2 size-500';
  }

  return (
    <div className={`${classsName} program-card-wrapper`}>
      <div className="program-card">
        <header>
          <div className="options">
            <DropdownButton
              as={ButtonGroup}
              variant="link"
              title={(
                <IconWithText
                  iconClassName="small-icon options-icon"
                />
)}
            >
              <Dropdown.Item
                eventKey="1"
                onClick={() => window.open(invoice.attributes.download_url, '_blank')}
              >
                <IconWithText
                  iconClassName="small-icon download-icon"
                >
                  Download
                </IconWithText>
              </Dropdown.Item>

            </DropdownButton>
          </div>
          <IconWithText
            wrapperClassName="align-items-start"
            iconClassName="invoice-icon"
          >
            <div className="me-5 mb-3">
              <h6 className="mb-0">
                Invoice #
                {invoice.attributes.number}
              </h6>
              <small className="fw-light text-primary">Paid</small>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="fw-light small">Issued on</div>
                <div className="fw-semibold">{invoice.attributes.issued_at_formatted}</div>
              </div>
              <div className="col-md-3 mb-3">
                <div className="fw-light small">Credits</div>
                <div className="fw-semibold">{invoice.attributes.count_credits}</div>
              </div>
              <div className="col-md-3 mb-3">
                <div className="fw-light small">Total</div>
                <div className="fw-semibold">{invoice.attributes.total_formatted}</div>
              </div>
            </div>
          </IconWithText>

        </header>
      </div>
    </div>
  );
}

InvoiceCard.propTypes = {
  size: PropTypes.object.isRequired,
  invoice: PropTypes.object.isRequired,
};
